<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'CourseNotes',
  data () {
    return {
    }
  },
  computed: {
    ...mapState('courses', {
      courseForm: state => state.courseForm
    })
  },
  methods: {
    ...mapMutations('courses', [
      'updateCourseForm'
    ])
  }
}
</script>

<template>
  <div class="layout-padding">
    <q-field class="q-pa-md">
      <q-input
        inverted-light
        color="grey-12"
        rows="7"
        type="textarea"
        float-label="Notes"
        :max-height="100"
        :value="courseForm.NOTES"
        @keyup.stop="updateCourseForm({ field: 'NOTES', value: $event.target.value })"
      />
    </q-field>
  </div>
</template>

<style>
</style>
